import { CHANNEL_FILTER_TYPES } from 'gcs-common/helper/channelTypeHelper';
import PropTypes from 'prop-types';
import ChannelTypeSelectionTab from '../ChannelTypeSelectionTab/ChannelTypeSelectionTab';
import styles from './styles.module.scss';

export default function ChannelTypeSelector({ hideCount = false }) {
  return (
    <div className={styles.channelSort}>
      <ChannelTypeSelectionTab hideCount={hideCount} filterType={CHANNEL_FILTER_TYPES.TEAM_CHATS} />
      <ChannelTypeSelectionTab hideCount={hideCount} filterType={CHANNEL_FILTER_TYPES.DIRECT_CHATS} />
    </div>
  );
}

ChannelTypeSelector.propTypes = {
  hideCount: PropTypes.bool,
};
